import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('deviceCycle', ['cachedCycles', 'selectedCycle']),
}

export const Methods = mapActions('deviceCycle', [
  'fetchCycles',
  'selectCycle',
  'updateCycle',
])
